export class GenericFormHelper {
	/**
	 * HELPER FUNCTIONS
	 * event to get items in dropdown format for generic integration values
	 * @param items
	 * @param labelKey
	 * @param valueKey
	 * @returns
	 */
	public static getDropdownValues(items, labelKey, valueKey): any {
		return items.map((item: any) => {
			return {
				label: item[labelKey],
				value: item[valueKey],
			};
		});
	}
}
